'use strict'

export default {
	name: 'utils',
  router:{},
	checkReturnCode(response, errorInfo) {
		let returnCode = response.data.header.returnCode
		switch (returnCode) {
			case '100004': // 需要认证
			
				return '需要认证'

			case '100002': // 未找到服务
				return errorInfo + ',请联系运维人员'

			case '100003': // 参数错误
				return errorInfo + ',请联系运维人员'

			case '200001': // 服务器端处理错误
				return errorInfo + ',请联系运维人员'

			case '200002': // 处理超时
				return errorInfo + ',请稍后重试'

			case '200003': // 服务内部调用其他服务无法访问
				return errorInfo + ',请联系运维人员'

			case '300001': // 网关处理错误
				return errorInfo + ',请联系运维人员'

      case '100005':
        this.router.push({path: '/denyAccess'})
		}
	}
}



// WEBPACK FOOTER //
// ./src/utils/utils.js